import script from "./MediaflowGraphicsDock.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowGraphicsDock.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowGraphicsDock.vue?vue&type=style&index=0&id=019fdb24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019fdb24"]])

export default __exports__